import classnames from 'classnames'
import { Component, ReactNode } from 'react'
import { DEFAULT_TOPIC_FIELDS } from '../../../../constants'
import { MiscNoteFieldDto } from '../../../../definition/notes.dto'

import plusIcon from './../../../../styles/images/plus-icon.png'

const EMPTY = ''

export interface EditFieldProps {
  fields?: MiscNoteFieldDto[]

  onSaveCb: (fields: MiscNoteFieldDto[]) => void
}

export interface EditFieldState {
  fields?: MiscNoteFieldDto[]
}

export class EditField extends Component<EditFieldProps, EditFieldState> {
  constructor(props: EditFieldProps) {
    super(props)

    this.state = this.generateFields()
  }

  generateFields = () => {
    const fields = this.props.fields
    DEFAULT_TOPIC_FIELDS.forEach((dfField) => {
      if (!this.props.fields?.find((topicField) => topicField.name === dfField)) {
        fields?.push({
          name: dfField,
          check: false,
          fieldValue: ''
        })
      }
    })

    return {
      fields: fields
    }
  }

  render(): ReactNode {
    return (
      <div className='new-note-topic'>
        <div className={classnames('column')}>
          <div className='label-input'>
            <label>Fields</label>
            <div className='fields'>
              {this.state.fields?.map((field, index) => {
                return (
                  <div className='row'>
                    <div className='checkbox'>
                      <input
                        type='checkbox'
                        checked={!!field.check}
                        onChange={() => {
                          const item = this.state.fields?.[index]
                          item!.check = !field.check
                          this.forceUpdate()
                          this.props.onSaveCb(this.state.fields!)
                        }}
                      />
                    </div>
                    {field.name !== EMPTY ? (
                      <label>{field.name}</label>
                    ) : (
                      <input
                        onBlur={(event) => {
                          const emptyFieldValue = event.target.value
                          const item = this.state.fields?.[index]
                          item!.name = emptyFieldValue
                          item!.check = this.state.fields?.[index].check || false
                          this.forceUpdate()
                          this.props.onSaveCb(this.state.fields!)
                        }}
                      />
                    )}
                  </div>
                )
              })}
              {this.state.fields?.[this.state.fields.length - 1].name !== EMPTY && (
                <div className='add-empty-field'>
                  <img
                    src={plusIcon}
                    alt='Add Field'
                    onClick={() => {
                      this.state.fields!.push({
                        name: EMPTY,
                        check: false,
                        fieldValue: ''
                      })
                      this.forceUpdate()
                    }}
                  />
                  <label>Add Empty Field</label>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
